<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex>Add Homepage Course</v-flex>  
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-flex wrap style="padding: 10px;">
                        <v-select item-value='_id' item-text='name' return-object v-model="SelectedCourse" :items="GetCourseDetailList" label="Select Course">
                                <template slot='selection' slot-scope='{ item }'>
                                    {{ item.Course_Title }}
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    {{ item.Course_Title }}    
                                </template>
                        </v-select>
                        <v-flex>
                            <v-select v-model="SelectedPosition" :items="Items" label="Select Position"></v-select>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-flex style="text-align: right;">
                        <v-btn color="success" @click="SubmitCourseHomepage">Add Homepage Course</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>

export default {
    props: ['dialog'],
    data(){
        return {

            SelectedCourse          : {},
            Position                : 0,
            SelectedPosition        : 1,
            Items                   : [1,2,3,4,5]

        }
    },
    computed:{
        GetCourseDetailList(){
            
            return this.$store.getters.GetCourseDetailsList
        }
    },
    methods:{
        CloseDialog(){
            
            this.ClearForm()
            this.$emit('close')
        },
        GetCourseDetailsList(){

            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getallcoursedetailslist`)
                        .then(response =>{
                        
                            this.$store.commit('SetCourseDetailList',response["data"]["response"])
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })

        },
        SubmitCourseHomepage(){
                
                let Course_Homepage = {}
                Course_Homepage['Course_Id'] = this.SelectedCourse['_id']
                Course_Homepage['Position']  = this.SelectedPosition
                
                this.$http.post(`${this.$store.getters.GetProductionUrl}/banners/updatehomepagecourse`,Course_Homepage)
                            .then(response =>{
                                
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated","Color":"green","Close": false });
                                this.CloseDialog()

                            })
                            .catch(err =>{
    
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Update","Color":"green","Close": false });
                            })
        },
        ClearForm(){
            this.SelectedCourse = {}
            this.SelectedCourse = 1
        }
    }
}
</script>
<style scoped>

</style>